// extracted by mini-css-extract-plugin
export default {"fullWidth":"mn-z","image":"nn-z","lazyLoadPicture":"on-z","lazyLoadSpinner":"pn-z","lazyLoadSpin":"qn-z","lazyLoadImage":"rn-z","hasStyledAspectRatio":"sn-z"};